"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _utils = require("../../utils");

var actions = _interopRequireWildcard(require("./actions"));

//  eslint-disable-next-line max-lines-per-function
var sagasFactory = function (_temp) {
  var _marked =
  /*#__PURE__*/
  _regenerator.default.mark(createResource),
      _marked2 =
  /*#__PURE__*/
  _regenerator.default.mark(createResourceList),
      _marked3 =
  /*#__PURE__*/
  _regenerator.default.mark(readResourceList),
      _marked4 =
  /*#__PURE__*/
  _regenerator.default.mark(readResourceDetail),
      _marked5 =
  /*#__PURE__*/
  _regenerator.default.mark(updateResource),
      _marked6 =
  /*#__PURE__*/
  _regenerator.default.mark(deleteResource),
      _marked7 =
  /*#__PURE__*/
  _regenerator.default.mark(watchResourceCreateRequest),
      _marked8 =
  /*#__PURE__*/
  _regenerator.default.mark(watchResourceListCreateRequest),
      _marked9 =
  /*#__PURE__*/
  _regenerator.default.mark(watchResourceListReadRequest),
      _marked10 =
  /*#__PURE__*/
  _regenerator.default.mark(watchResourceDetailReadRequest),
      _marked11 =
  /*#__PURE__*/
  _regenerator.default.mark(watchResourceUpdateRequest),
      _marked12 =
  /*#__PURE__*/
  _regenerator.default.mark(watchResourceDeleteRequest),
      _marked13 =
  /*#__PURE__*/
  _regenerator.default.mark(rootSaga);

  var _ref = _temp === void 0 ? {} : _temp,
      camelCaseKeyPred = _ref.camelCaseKeyPred,
      snakeCaseKeyPred = _ref.snakeCaseKeyPred;

  var camelKeys = (0, _utils.createCamelKeys)(camelCaseKeyPred);
  var snakeKeys = (0, _utils.createSnakeKeys)(snakeCaseKeyPred);

  var resourceNeedlePath = function (resource, needle) {
    if (!needle) return `/${resource}`;
    return `/${resource}/${needle}`;
  };

  var apiResponseData = function (autoCaseKeys, response) {
    return autoCaseKeys ? camelKeys(response.data) : response.data;
  };

  var apiResponseToPayload = function (autoCaseKeys, response) {
    return {
      api: {
        response
      },
      data: apiResponseData(autoCaseKeys, response)
    };
  };

  function createResource(api, _ref2, _ref3) {
    var data, resource, thunk, entityType, autoCaseKeys, resp, action;
    return _regenerator.default.wrap(function (_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = _ref2.data;
            resource = _ref3.resource, thunk = _ref3.thunk, entityType = _ref3.entityType, autoCaseKeys = _ref3.autoCaseKeys;
            _context.prev = 2;
            _context.next = 5;
            return (0, _effects.call)([api, api.post], `/${resource}`, autoCaseKeys ? snakeKeys(data) : data);

          case 5:
            resp = _context.sent;
            action = actions.resourceCreateSuccess(resource, entityType, apiResponseToPayload(autoCaseKeys, resp), {
              data
            }, thunk);
            _context.next = 9;
            return (0, _effects.put)(action);

          case 9:
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            _context.next = 15;
            return (0, _effects.put)(actions.resourceCreateFailure(resource, entityType, autoCaseKeys ? camelKeys(_context.t0) : _context.t0, {
              data
            }, thunk));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _marked, null, [[2, 11]]);
  }

  function createResourceList(api, _ref4, _ref5) {
    var data, resource, thunk, entityType, autoCaseKeys, params, resp, action;
    return _regenerator.default.wrap(function (_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            data = _ref4.data;
            resource = _ref5.resource, thunk = _ref5.thunk, entityType = _ref5.entityType, autoCaseKeys = _ref5.autoCaseKeys;
            params = autoCaseKeys ? snakeKeys(data) : data;
            _context2.prev = 3;
            _context2.next = 6;
            return (0, _effects.call)([api, api.post], `/${resource}`, params);

          case 6:
            resp = _context2.sent;
            action = actions.resourceListCreateSuccess(resource, entityType, apiResponseToPayload(autoCaseKeys, resp), params, thunk);
            _context2.next = 10;
            return (0, _effects.put)(action);

          case 10:
            _context2.next = 16;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](3);
            _context2.next = 16;
            return (0, _effects.put)(actions.resourceListCreateFailure(resource, entityType, autoCaseKeys ? camelKeys(_context2.t0) : _context2.t0, data, thunk));

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _marked2, null, [[3, 12]]);
  }

  function readResourceList(api, _ref6, _ref7) {
    var params, resource, thunk, entityType, autoCaseKeys, resp;
    return _regenerator.default.wrap(function (_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            params = _ref6.params;
            resource = _ref7.resource, thunk = _ref7.thunk, entityType = _ref7.entityType, autoCaseKeys = _ref7.autoCaseKeys;
            _context3.prev = 2;
            _context3.next = 5;
            return (0, _effects.call)([api, api.get], `/${resource}`, params);

          case 5:
            resp = _context3.sent;
            _context3.next = 8;
            return (0, _effects.put)(actions.resourceListReadSuccess(resource, entityType, apiResponseToPayload(autoCaseKeys, resp), {
              params
            }, thunk));

          case 8:
            _context3.next = 14;
            break;

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](2);
            _context3.next = 14;
            return (0, _effects.put)(actions.resourceListReadFailure(resource, entityType, autoCaseKeys ? camelKeys(_context3.t0) : _context3.t0, {
              params
            }, thunk));

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _marked3, null, [[2, 10]]);
  }

  function readResourceDetail(api, _ref8, _ref9) {
    var needle, params, resource, thunk, entityType, autoCaseKeys, resp;
    return _regenerator.default.wrap(function (_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            needle = _ref8.needle, params = _ref8.params;
            resource = _ref9.resource, thunk = _ref9.thunk, entityType = _ref9.entityType, autoCaseKeys = _ref9.autoCaseKeys;
            _context4.prev = 2;
            _context4.next = 5;
            return (0, _effects.call)([api, api.get], resourceNeedlePath(resource, needle), params);

          case 5:
            resp = _context4.sent;
            _context4.next = 8;
            return (0, _effects.put)(actions.resourceDetailReadSuccess(resource, entityType, apiResponseToPayload(autoCaseKeys, resp), {
              needle,
              params
            }, thunk));

          case 8:
            _context4.next = 14;
            break;

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](2);
            _context4.next = 14;
            return (0, _effects.put)(actions.resourceDetailReadFailure(resource, entityType, autoCaseKeys ? camelKeys(_context4.t0) : _context4.t0, {
              needle,
              params
            }, thunk));

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _marked4, null, [[2, 10]]);
  }

  function updateResource(api, _ref10, _ref11) {
    var needle, data, resource, thunk, entityType, autoCaseKeys, resp;
    return _regenerator.default.wrap(function (_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            needle = _ref10.needle, data = _ref10.data;
            resource = _ref11.resource, thunk = _ref11.thunk, entityType = _ref11.entityType, autoCaseKeys = _ref11.autoCaseKeys;
            _context5.prev = 2;
            _context5.next = 5;
            return (0, _effects.call)([api, api.put], resourceNeedlePath(resource, needle), autoCaseKeys ? snakeKeys(data) : data);

          case 5:
            resp = _context5.sent;
            _context5.next = 8;
            return (0, _effects.put)(actions.resourceUpdateSuccess(resource, entityType, apiResponseToPayload(autoCaseKeys, resp), {
              needle,
              data
            }, thunk));

          case 8:
            _context5.next = 14;
            break;

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](2);
            _context5.next = 14;
            return (0, _effects.put)(actions.resourceUpdateFailure(resource, entityType, autoCaseKeys ? camelKeys(_context5.t0) : _context5.t0, {
              needle,
              data
            }, thunk));

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _marked5, null, [[2, 10]]);
  }

  function deleteResource(api, _ref12, _ref13) {
    var needle, resource, thunk, entityType, autoCaseKeys, resp;
    return _regenerator.default.wrap(function (_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            needle = _ref12.needle;
            resource = _ref13.resource, thunk = _ref13.thunk, entityType = _ref13.entityType, autoCaseKeys = _ref13.autoCaseKeys;
            _context6.prev = 2;
            _context6.next = 5;
            return (0, _effects.call)([api, api.delete], resourceNeedlePath(resource, needle));

          case 5:
            resp = _context6.sent;
            _context6.next = 8;
            return (0, _effects.put)(actions.resourceDeleteSuccess(resource, entityType, apiResponseToPayload(autoCaseKeys, resp), {
              needle
            }, thunk, resp.status === 200 // update on 200
            ));

          case 8:
            _context6.next = 14;
            break;

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](2);
            _context6.next = 14;
            return (0, _effects.put)(actions.resourceDeleteFailure(resource, entityType, autoCaseKeys ? camelKeys(_context6.t0) : _context6.t0, {
              needle
            }, thunk));

          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _marked6, null, [[2, 10]]);
  }

  function watchResourceCreateRequest(api, _ref14) {
    var payload, meta;
    return _regenerator.default.wrap(function (_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            payload = _ref14.payload, meta = _ref14.meta;
            _context7.next = 3;
            return (0, _effects.call)(createResource, api, payload, meta);

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _marked7);
  }

  function watchResourceListCreateRequest(api, _ref15) {
    var payload, meta;
    return _regenerator.default.wrap(function (_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            payload = _ref15.payload, meta = _ref15.meta;
            _context8.next = 3;
            return (0, _effects.call)(createResourceList, api, payload, meta);

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _marked8);
  }

  function watchResourceListReadRequest(api, _ref16) {
    var payload, meta;
    return _regenerator.default.wrap(function (_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            payload = _ref16.payload, meta = _ref16.meta;
            _context9.next = 3;
            return (0, _effects.call)(readResourceList, api, payload, meta);

          case 3:
          case "end":
            return _context9.stop();
        }
      }
    }, _marked9);
  }

  function watchResourceDetailReadRequest(api, _ref17) {
    var payload, meta;
    return _regenerator.default.wrap(function (_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            payload = _ref17.payload, meta = _ref17.meta;
            _context10.next = 3;
            return (0, _effects.call)(readResourceDetail, api, payload, meta);

          case 3:
          case "end":
            return _context10.stop();
        }
      }
    }, _marked10);
  }

  function watchResourceUpdateRequest(api, _ref18) {
    var payload, meta;
    return _regenerator.default.wrap(function (_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            payload = _ref18.payload, meta = _ref18.meta;
            _context11.next = 3;
            return (0, _effects.call)(updateResource, api, payload, meta);

          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, _marked11);
  }

  function watchResourceDeleteRequest(api, _ref19) {
    var payload, meta;
    return _regenerator.default.wrap(function (_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            payload = _ref19.payload, meta = _ref19.meta;
            _context12.next = 3;
            return (0, _effects.call)(deleteResource, api, payload, meta);

          case 3:
          case "end":
            return _context12.stop();
        }
      }
    }, _marked12);
  }

  function rootSaga(_ref20) {
    var api, safe;
    return _regenerator.default.wrap(function (_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            api = _ref20.api;
            safe = (0, _utils.safeSaga)(_utils.consoleErrorRecovery);
            _context13.next = 4;
            return (0, _effects.takeEvery)(actions.RESOURCE_CREATE_REQUEST, safe(watchResourceCreateRequest, api));

          case 4:
            _context13.next = 6;
            return (0, _effects.takeEvery)(actions.RESOURCE_LIST_CREATE_REQUEST, safe(watchResourceListCreateRequest, api));

          case 6:
            _context13.next = 8;
            return (0, _effects.takeEvery)(actions.RESOURCE_LIST_READ_REQUEST, safe(watchResourceListReadRequest, api));

          case 8:
            _context13.next = 10;
            return (0, _effects.takeEvery)(actions.RESOURCE_DETAIL_READ_REQUEST, safe(watchResourceDetailReadRequest, api));

          case 10:
            _context13.next = 12;
            return (0, _effects.takeEvery)(actions.RESOURCE_UPDATE_REQUEST, safe(watchResourceUpdateRequest, api));

          case 12:
            _context13.next = 14;
            return (0, _effects.takeEvery)(actions.RESOURCE_DELETE_REQUEST, safe(watchResourceDeleteRequest, api));

          case 14:
          case "end":
            return _context13.stop();
        }
      }
    }, _marked13);
  }

  return {
    apiResponseData,
    apiResponseToPayload,
    createResource,
    createResourceList,
    deleteResource,
    readResourceDetail,
    readResourceList,
    resourceNeedlePath,
    updateResource,
    watchResourceCreateRequest,
    watchResourceDeleteRequest,
    watchResourceDetailReadRequest,
    watchResourceListCreateRequest,
    watchResourceListReadRequest,
    watchResourceUpdateRequest,
    rootSaga
  };
};

var _default = sagasFactory;
exports.default = _default;